import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { SuppliersContextProvider } from "../../Context/SuppliersContext";
import SupplierForm from "./SupplierForm";
import useFetch from "../../../hooks/useFetch";
import HistoryList from "./HistoryList";
import Body from "../../Common/Body";

const Supplier = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [supplier, setSupplier] = useState({});
  const { id } = useParams();
  const { get } = useFetch();

  useEffect(() => {
    if (id === "new") {
      setSupplier({
        supplierId: null,
        businessName: "",
        address: "",
        cuit: "",
        phone: "",
      });
      setIsLoading(false);
    } else {
      get(`/suppliers/${id}`)
        .then(async (res) => {
          setSupplier(res);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  return (
    <SuppliersContextProvider>
      <Body
        title={`Proveedor ${supplier.id ? supplier.id : "Nuevo"}`}
        isLoading={isLoading}
      >
        <Box>
          {id === "new" ? (
            <SupplierForm supplier={supplier} id={id}></SupplierForm>
          ) : (
            <>
              <SupplierForm supplier={supplier} id={id}></SupplierForm>
              <HistoryList supplier={supplier}></HistoryList>
            </>
          )}
        </Box>
      </Body>
    </SuppliersContextProvider>
  );
};

export default Supplier;
